import history from "../history";
import store from "../store";
import { tryLogout } from "../actions/authActions";
import { setError } from "../actions/errorActions";

const errorHandler = (error, onFieldError) => {
    if (error.response) {
        if (error.response.data.error) {
            if (error.response.data.error[0].type) {
                if (error.response.data.error[0].type === "session") store.dispatch(tryLogout());
                else if (error.response.data.error[0].type === "inactive") history.push("/inactive");
                else if (error.response.data.error[0].type === "unassigned") history.push("/unassigned");
                else store.dispatch(setError(error.response.status, error.response.statusText, error.response.data.error[0].message));
            }
            else if (error.response.data.error[0].field && onFieldError) onFieldError(error.response);
            else console.log("Nieobsłużony błąd");
        }
        else store.dispatch(setError(error.response.status, error.response.statusText, [""]));
    }
    else store.dispatch(setError(503, "Service Unavailable", ["Docelowy serwer jest czasowo niedostępny"]));
};

export default errorHandler;